(function () {
    'use strict';

    angular.module('authService', [])

    .factory('authenticationService', function () {
        return {
            isAuthenticated: false,
            isAdmin: false
        };
    })

    .factory('userService', function($http, $window, $location, $cookies) {

        var currentUser = {
            user_id: 0,
            user_name: 'not set',
            user_role:'',
            display_name:'',
            token: ''
        };
        return {
            logIn: function(loginData) {
                return $http({
                    method: 'POST',
                    url: '/apis/users.cfc?method=user_login',
                    data: $.param(loginData), // jquery pass in data as strings
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
            },
            logOut: function() {

              /*return $http({
                  method: 'POST',
                  url: '/apis/users.cfc?method=user_logout',
                  data: $.param(loginData), // jquery pass in data as strings
                  headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                  }
              });*/
              $cookies.remove("token");
              $cookies.remove("user_id");
              $cookies.remove("loginReturnURL");

              currentUser = {
                  user_id: 0,
                  user_name: 'not set',
                  user_role:'',
                  display_name:'',
                  token: ''
              };
              $location.path('/login');

            },

            getCurrentUser:function () {
                // check if user refreshed page
                if (currentUser.user_id === 0 &&
                    angular.isDefined($cookies.get('user_id'))) {
                        currentUser = {
                            user_id:$cookies.get('user_id'),
                            user_name:$cookies.get('user_name'),
                            user_role:$cookies.get('user_role'),
                            display_name:$cookies.get('display_name'),
                            token:$cookies.get('token')
                        };
                        console.log('pull from cache');
                }
                return currentUser;
            },
            setCurrentUser:function (data) {
                currentUser = {
                    user_id:data.user_id,
                    user_name:data.user_name,
                    user_role:data.user_role,
                    display_name:data.display_name,
                    token:data.token
                };
            }
        }
    })

    .factory('tokenInterceptor', function ($q, $window, $location, $cookies, authenticationService) {
        return {
            request: function (config) {
                config.headers = config.headers || {};
                if ($cookies.get('token')) {
                    config.headers.Authorization = 'Bearer ' + $cookies.get('token');
                }
                return config;
            },

            requestError: function (rejection) {
                return $q.reject(rejection);
            },

            /* Set Authentication.isAuthenticated to true if 200 received*/
            response: function (response) {
                if (response !== null && response.status === 200 &&
                    $cookies.get('token') &&
                    !authenticationService.isAuthenticated) {
                    authenticationService.isAuthenticated = true;
                }
                return response || $q.when(response);
            },

            /* Revoke client authentication if 401 is received */
            responseError: function (rejection) {

                if (rejection !== null && rejection.status === 401 &&
                    ($cookies.get('token') || authenticationService.isAuthenticated)) {

                    $cookies.remove("token");
                    $cookies.remove("user_id");

                    authenticationService.isAuthenticated = false;

                    $cookies.put('loginReturnURL', $location.path());
                    
                    $location.path('/login/');
                }

                return $q.reject(rejection);
            }
        };
    });
})();
